let defaultState = {
  socket: null,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SETUP_SOCKET':
      return {
        ...state,
        socket: action.socket,
      }
    default:
      return state
  }
}
